module.exports = __webpack_public_path__ + "static/media/sub_visited.18a0c907.png";